import axios from 'axios';

const BASE = '/machinesim/api/sim-defs';

export async function listMachineTypes(params = {}) {
  const res = await axios.get(`${BASE}/machine-types`, { params });
  return res.data;
}

export async function getHmiDefByMachineTypeId(id) {
  const res = await axios.get(`${BASE}/machine-types/${encodeURIComponent(id)}/hmi-def`);
  return res.data;
}

export async function getHmiDefByTypeCode(code) {
  const res = await axios.get(`${BASE}/machine-types/by-code/${encodeURIComponent(code)}/hmi-def`);
  return res.data;
}

export async function patchFieldHmi(fieldId, body) {
  const res = await axios.patch(`${BASE}/fields/${encodeURIComponent(fieldId)}/hmi`, body);
  return res.data;
}

export async function getHmiContext(machineName, typeCode) {
  const params = typeCode ? { typeCode } : {};
  const res = await axios.get(
    `/machinesim/api/machines/${encodeURIComponent(machineName)}/hmi-context`,
    { params }
  );
  return res.data;
}

export async function patchMachineType(id, body) {
  const res = await axios.patch(`${BASE}/machine-types/${encodeURIComponent(id)}`, body);
  return res.data;
}
